import { render } from "./EnterPwnBtn.vue?vue&type=template&id=86997ac6&scoped=true"
const script = {}

import "./EnterPwnBtn.vue?vue&type=style&index=0&id=86997ac6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86997ac6"]])

export default __exports__